import type { StaticLayerPayload } from "@config";
import { Set } from "@library-containers/layers";
import { FullscreenView } from "./Fullscreen.view";

export const FullscreenLibrary = ({ entity }: StaticLayerPayload) => {
  const { children, settings, id } = entity;
  return (
    <FullscreenView entity={entity}>
      {children.map((child, index) => (
        <Set
          key={child.id}
          entity={{
            ...child,
            layers: {
              ...(entity.layers || {}),
              combo: { settings, index, id },
            },
          }}
        />
      ))}
    </FullscreenView>
  );
};
